/**
 * Main collection collection-tabs (integrates with Dawn facets)
 *
 * Tabs switch the current collection (path) while preserving the current query
 * string (filters/sort) so it continues to work with Dawn facets as usual.
 *
 * Safety-first: switching collection navigates to the new collection URL.
 * Dawn facets will still work normally on that new page.
 */

(function () {
  const TAB_SELECTOR = '[data-collection-tab-filter]';

  function getSearchParams() {
    return new URLSearchParams(window.location.search);
  }

  function navigateToCollection(collectionUrl) {
    if (!collectionUrl) return;

    const params = getSearchParams();
    // Reset pagination when switching collection
    params.delete('page');
    // Ensure we never persist section fetch param
    params.delete('section_id');

    const query = params.toString();
    const url = new URL(collectionUrl, window.location.origin);
    url.search = query;

    window.location.href = url.toString();
  }

  function updateActiveTabs() {
    document.querySelectorAll(TAB_SELECTOR).forEach((tab) => {
      const raw = tab.getAttribute('data-collection-url') || tab.getAttribute('href') || '';
      if (!raw) return;

      let tabPath = '';
      try {
        tabPath = new URL(raw, window.location.origin).pathname.replace(/\/+$/, '');
      } catch (e) {
        tabPath = '';
      }

      const currentPath = window.location.pathname.replace(/\/+$/, '');
      const isActive = tabPath !== '' && tabPath === currentPath;

      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  // Event delegation (works even after ProductGridContainer replaces HTML)
  document.addEventListener('click', (event) => {
    const tab = event.target.closest(TAB_SELECTOR);
    if (!tab) return;

    // If the tab is disabled (no collection), do nothing.
    if (tab.getAttribute('aria-disabled') === 'true') return;

    event.preventDefault();

    const collectionUrl = tab.getAttribute('data-collection-url') || tab.getAttribute('href') || '';
    navigateToCollection(collectionUrl);
  });

  // Keep active state in sync when Dawn updates URL (pushState) or on back/forward
  (function patchHistory() {
    const pushState = history.pushState;
    const replaceState = history.replaceState;

    function dispatch() {
      window.dispatchEvent(new Event('locationchange'));
    }

    history.pushState = function () {
      pushState.apply(history, arguments);
      dispatch();
    };

    history.replaceState = function () {
      replaceState.apply(history, arguments);
      dispatch();
    };

    window.addEventListener('popstate', dispatch);
  })();

  window.addEventListener('locationchange', updateActiveTabs);
  document.addEventListener('DOMContentLoaded', updateActiveTabs);
})();

